import { forEach } from 'lodash-es';
import { IGetOrderItemResponse } from '../proto/order/orderItem';

export const getOrderItemFinalPrice = (orderItem: IGetOrderItemResponse): number => {
	let totalAddOns = 0;

	forEach(orderItem.customizationGroups, (customizationGroup) => {
		forEach(customizationGroup.selections, (selection) => {
			totalAddOns += selection.priceAddOn * (selection.quantity ?? 1);
		});
	});

	return (orderItem.quantity ?? 1) * (orderItem.price + totalAddOns);
};
